var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0263 43.5913C34.0104 43.5913 43.7254 33.8841 43.7254 21.9096C43.7254 9.93522 34.0104 0.228027 22.0263 0.228027C10.0423 0.228027 0.327332 9.93522 0.327332 21.9096C0.327332 33.8841 10.0423 43.5913 22.0263 43.5913Z",
    fill: "#F4F4F4",
    stroke: "black",
    strokeWidth: 0.396319
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 31.7946H17.6294C14.5948 31.7946 12.1338 29.3356 12.1338 26.3034V17.5166C12.1338 14.4845 14.5948 12.0254 17.6294 12.0254H26.4233C29.4578 12.0254 31.9189 14.4845 31.9189 17.5166V23.0078",
    stroke: "black",
    strokeWidth: 1.18896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8246 19.1138C26.3693 20.6584 26.3693 23.1614 24.8246 24.7049C23.2787 26.2484 20.7737 26.2484 19.2279 24.7049C17.6831 23.1614 17.6831 20.6584 19.2279 19.1138C19.9695 18.3716 20.977 17.9556 22.0262 17.9556C23.0755 17.9556 24.083 18.3716 24.8246 19.1138Z",
    stroke: "black",
    strokeWidth: 1.18896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5219 30.1401H33.0175",
    stroke: "black",
    strokeWidth: 1.18896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2697 32.8857V27.3945",
    stroke: "black",
    strokeWidth: 1.18896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.20b1569b19af581da8db1988358438d1.svg";
export { ForwardRef as ReactComponent };